



































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';

import TitleBar from '@/components/Elements/TitleBar.vue'
import cloneDeep from 'lodash/cloneDeep';

import ProducedProductForm from './ProducedProductForm/ProducedProductForm.vue'

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'filter',

      'documents', 'typeTabs', 'lastMeta'
    ]),
  },
  components: {
    TitleBar
  }
})
export default class ProducedProduct extends Vue {
  radioButton = 1;

  documents!: any[];
  // Вкладки типов приходят из стора: посчитаны на бэкенде по всем продуктам
  typeTabs!: any[];

  activeTypeId: any = null;

  get titleStack () {
    return [
      'Продукты', 'Продукты производства'
    ]
  }

  @Watch('typeTabs')
  onTypeTabsChange(tabs: any[]) {
    const exists = tabs.some((tab: any) => tab.id === this.activeTypeId);
    if (!exists) {
      // по умолчанию активна первая вкладка; если активный тип исчез — сброс на первую
      this.activeTypeId = tabs.length ? tabs[0].id : null;
    }
  }

  @Watch('activeTypeId')
  onActiveTypeChange() {
    const { page, ...rest } = this.$route.query
    // page от пагинации приходит числом — сравниваем через Number()
    if (page === undefined || Number(page) === 1) {
      // page нет или уже 1 — replace не изменит query (NavigationDuplicated,
      // вотч $route.query не сработает), грузим новую вкладку явно
      this.handleParamsChange()
    } else {
      // смена вкладки всегда с первой страницы — иначе stale page даёт пустой список
      this.$router.replace({ query: { ...rest, page: '1' } }).catch(() => { /* дублирующая навигация — не ошибка */ })
    }
  }

  get queryParams() {
    return cloneDeep(this.$route.query);
  }

  get defaultSort() {
    return [this.$route.query.sortField || 'name', this.$route.query.sortDirection || 'asc']
  }

  get selectedView() {
    return this.$route.query.view || 'linked'
  }

  setFilter(filterName: string, filterValue: any) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        [filterName]: filterValue
      }
    })
  }

  onSort(field: string, direction: string) {
    console.log('onSort', field, direction)
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }

  private delayFilter: any = null
  private delayFilterValue: any = null

  onSearch(filter: string, value: any) {
    if (!this.delayFilter) {
      setTimeout(() => {
        // новый поиск — с первой страницы
        const { page, ...rest } = this.$route.query
        this.$router.replace({
          query: {
            ...rest, [this.delayFilter]: this.delayFilterValue
          }
        })
        this.delayFilter = null
      }, 3000)
    }
    this.delayFilter = filter
    this.delayFilterValue = value
  }

  onPageChange(page: string) {
    console.log('onPageChange', page)
    this.$router.replace({
      query: { ...this.$route.query, page }
    })
  }

  openDocument(row: any) {
    this.$buefy.modal.open({
      component: ProducedProductForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        initParams: {
          is_active: row.is_active
        }
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form full-form',
      parent: this
    })
  }

  public copyDocument(row: any) {
    this.$buefy.dialog.confirm({
      message: `Сделать копию партии ${row.name}?`,
      confirmText: 'Копировать',
      cancelText: 'Отмена',
      trapFocus: true,
      onConfirm: (value: any) => {
        this.$store.dispatch(`${STORE_KEY}/copyDocument`, {
          id: row.id
        })
        .then(() => {
          this.$buefy.snackbar.open(`Продукт успешно скопирован.`);
          this.handleParamsChange();
        })
        .catch((e: any) => {
          console.log(e)
          this.$buefy.snackbar.open({
            type: 'is-warning',
            message: `При сохранении возникли проблемы. Попробуйте позже.`
          })
        })
      }
    })
    
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.handleParamsChange();
  }

  beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    // фильтр активной вкладки комбинируется с поиском/пагинацией из route query
    this.$store.dispatch(`${STORE_KEY}/loadData`, {
      ...this.$route.query,
      product_type_id: this.activeTypeId
    })
  }

}
